<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información del Banco">
          <b-table 
              class="datos-objeto" 
              responsive="sm" 
              :items="bancoDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'bancos/getField',
  mutationType: 'bancos/updateField',
});

export default {
  name: 'BancosDatos',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      bancoId: 0,
      
      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],
    }
  },
  created() {
    if (this.$route.params){
      if (this.$route.params.id){
        this.bancoId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('bancos/getDatos', this.bancoId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  computed: {
    ...mapFields([
      'bancoDatos',
    ]),
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  }
}
</script>
